import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext, useResultContext } from 'common/components/CopyMagic/contexts';

const useTrackOnApply = () => {
  const { isEdited, result } = useResultContext();
  const contentId = result?.id;

  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(() => {
    const trackProductAnalytics = trackAnalytics(productEvents);

    trackProductAnalytics('Output Applied', {
      'Is Edited': isEdited(),
      'Content ID': contentId,
    });
  }, [productEvents, contentId, isEdited]);

  return trackCallback;
};

export default useTrackOnApply;
